import React, { FC, useCallback, useState } from 'react';
import { FontAwesomeSpriteIcon } from 'src/modules/shared/components/FontAwesomeLocal';
import {
  AppBar,
  Dialog,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Slide,
  Toolbar,
  useTheme,
} from '@material-ui/core';
import { SpriteIcon, SpriteIconsLight } from 'src/config/api/models/FontAwesome';
import { TransitionProps } from '@material-ui/core/transitions';
import { LogActionTypes, useDataLogging } from 'src/modules/shared/data-logging';

type ContactMenuItensProps = {
  icon: SpriteIcon;
  title: string;
  redirectTo?: string;
  url?: string;
  type: 'link' | 'video';
  log: LogActionTypes;
};

const contactMenuItens: ContactMenuItensProps[] = [
  {
    icon: SpriteIconsLight.CIRCLE_QUESTION,
    title: 'FAQ (vaakgestelde vragen)',
    redirectTo: 'https://www.lernova.be/faq',
    type: 'link',
    log: LogActionTypes.CONTACT_FORM_FAQ,
  },
  {
    icon: SpriteIconsLight.CIRCLE_USER,
    title: 'Contacteer ons',
    redirectTo: 'https://www.lernova.be/contact',
    type: 'link',
    log: LogActionTypes.CONTACT_FORM_CONTACT,
  },
  {
    icon: SpriteIconsLight.CIRCLE_PLAY,
    title: 'Startvideo voor leerlingen',
    type: 'video',
    log: LogActionTypes.CONTACT_FORM_TRAINNING_VIDEO,
  },
];

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children?: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const ContactMenu: FC = () => {
  const log = useDataLogging();
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [showVideo, setShowVideo] = useState<boolean>(false);

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
      log(LogActionTypes.CONTACT_FORM_CLICK);
    },
    [log]
  );
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleMenuClick = useCallback(
    (item: ContactMenuItensProps) => {
      if (item.type === 'link') {
        window.open(item.redirectTo, '_blank');
      } else {
        setShowVideo(true);
      }

      log(item.log, {
        title: item.title,
      });
      handleClose();
    },
    [log]
  );
  const handleCloseVideo = () => {
    setShowVideo(false);
  };

  return (
    <>
      <div className={'hide-on-print'}>
        <IconButton
          id="basic-button"
          style={{ padding: 0 }}
          onClick={handleClick}
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          <FontAwesomeSpriteIcon
            icon={SpriteIconsLight.COMMENTS_QUESTION_CHECK}
            color={theme.palette.offblack}
            iconSize="xl"
          />
        </IconButton>
        <Menu
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          style={{ top: theme.config.subHeaderHeightPx }}
          anchorEl={anchorEl}
          id="basic-menu"
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          {contactMenuItens.map((item, index) => {
            return (
              <div key={index}>
                <MenuItem onClick={() => handleMenuClick(item)}>
                  <div
                    style={{
                      display: 'flex',
                      gap: '12px',
                      height: '39px',
                      justifyContent: 'center',
                      alignItems: 'center',
                      color: theme.palette.secondary.main,
                    }}
                  >
                    <FontAwesomeSpriteIcon
                      icon={item.icon}
                      color={theme.palette.primary.main}
                      iconSize="lg"
                    />

                    {item.title}
                  </div>
                </MenuItem>
                {index !== contactMenuItens.length - 1 && (
                  <Divider style={{ width: '95%', margin: 'auto' }} />
                )}
              </div>
            );
          })}
        </Menu>
      </div>
      <Dialog
        fullScreen
        open={showVideo}
        onClose={handleCloseVideo}
        TransitionComponent={Transition}
      >
        <AppBar>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleCloseVideo} aria-label="close">
              X
            </IconButton>
          </Toolbar>
        </AppBar>
        <iframe
          src="https://player.vimeo.com/video/997670568?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
          title="2024-08-12_LE_Wegwijs_in_Lernova-Vimeo Export"
        ></iframe>
      </Dialog>
    </>
  );
};
